import { alpha, Box, styled } from '@mui/material';
import {
  chromeYellow, kiwiGreen, spaceCadet, ultraMarine,
} from '../../../../../../../../../../../../../utils/colors';

const StyledBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 6,

  '& .logic-body': {
    display: 'flex',
    alignItems: 'stretch',
    minWidth: 0,
  },

  '& .operator': {
    writingMode: 'vertical-rl',
    transform: 'rotate(180deg)',
    borderRadius: '0 6px 6px 0',
    padding: '8px 4px',
    minWidth: 24,
    textAlign: 'center',
    color: 'white',
    fontSize: 10,
    lineHeight: '12px',
    fontWeight: 700,
    letterSpacing: 0,
    '&.Sum': {
      backgroundColor: ultraMarine[500],
    },

    '&.Max': {
      backgroundColor: kiwiGreen[600],
    },

    '&.Min': {
      backgroundColor: chromeYellow[700],
    },

    '&.StrictMax': {
      backgroundColor: kiwiGreen[700],
      color: kiwiGreen[100],
    },
  },

  '& .content': {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    borderRadius: '0 6px 6px 0',
    border: `1px solid ${alpha(spaceCadet[300], 0.4)}`,
    backgroundColor: alpha(spaceCadet[100], 0.55),
    overflow: 'hidden',
  },

  '& .title': {
    color: spaceCadet[500],
    fontSize: 11,
    lineHeight: '14px',
    fontWeight: 700,
    letterSpacing: 0,
    textTransform: 'uppercase',
  },

  '& .line': {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    minWidth: 0,
    padding: '7px 10px',
    backgroundColor: 'transparent',
  },

  '& .line + .line': {
    borderTop: `1px solid ${alpha(spaceCadet[300], 0.35)}`,
  },

  '& .line > .MuiTypography-root': {
    flexShrink: 1,
    minWidth: 0,
  },

  '& .score': {
    marginLeft: 'auto',
    flex: '0 0 auto',
    color: spaceCadet[500],
    fontSize: 11,
    lineHeight: '14px',
    fontWeight: 600,
  },

  '& .nested': {
    borderRadius: 8,
    border: `1px solid ${alpha(spaceCadet[300], 0.5)}`,
    backgroundColor: 'white',
    padding: '8px 8px 8px 10px',

    '& .compliance-operation': {
      padding: '4px 0px',
    },
  },

  '& .nested-panel': {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
});

export default StyledBox;
